import React from 'react';
import SVG, { SVGProps } from './SVGWrapper';

export const NexusFlowerIcon = ({
  width = 24,
  height = 24,
  strokeWidth = 2,
  ...props
}: SVGProps) => {
  return (
    <SVG width={width} height={height} viewBox="0 0 24 24" {...props}>
      <defs>
        <linearGradient x1="0" y1="-34%" x2="94%" y2="100%" id="NexusFlowerGrad">
          <stop stopColor="#7CEBC4" offset="0%"></stop>
          <stop stopColor="#7DB1FA" offset="47%"></stop>
          <stop stopColor="#884BFA" offset="100%"></stop>
        </linearGradient>
      </defs>
      <path
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        d="M15 4.27A4.17 4.17 0 0 0 12.02 3c-2.2 0-4.25 1.8-4 4 .1.95.45 2.03.98 3M20.75 12.81c.51-.96.65-2.13.3-3.23-.7-2.1-3.03-3.48-5.05-2.56a8.46 8.46 0 0 0-2.55 1.86M14.4 20.92a4.17 4.17 0 0 0 3.17-.72c1.78-1.3 2.38-3.95.88-5.59a8.46 8.46 0 0 0-2.56-1.85M4.74 17.4c.15 1.07.73 2.1 1.66 2.77 1.79 1.3 4.49 1.05 5.59-.88.47-.83.82-1.9.96-3M5.1 7.1a4.17 4.17 0 0 0-2.13 2.44c-.68 2.1.4 4.6 2.57 5.04.93.2 2.07.2 3.16 0"
      />
    </SVG>
  );
};
